exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli.nav-item.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n", ""]);

// exports
